import { Component, ChangeDetectorRef, Renderer2, ViewChild, OnInit, ViewChildren, QueryList, AfterViewInit, inject, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LabTestList, LabTestRepeat, LabTestSampleRow, SampleIdentifierGroup } from '../../models/labTestRepeat';
import {
  MatTableDataSource,
  MatTable,
} from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { LabTestFilter, StatusUpdate, } from '../../models/lab-test';
import { LabTestListService } from '../../services/labTestList.service';
import { debounceTime, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { APIResponse } from '../../models/APIResponse';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../services/shared.service';
import { UserDetail } from '../../models/UserDetail';
import { ProjectService } from '../../services/project.service';
import { STATUS_CONSTANTS, STATUS_CONSTANTS_UC, roles, roleIds, filterDefaults, reportConstants } from '../../common/constants';
import { environment } from '../../../environments/environment';
import { MESSAGES_CONSTANTS as MC } from '../../common/messages-constants';
import { labTestsListConstants } from '../../common/texts-constants';
import { LoadingService } from '../../services/loading.service';
import { MaterialDesignModule } from '../../common/material-design/material-design.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-lab-tests-list',
  templateUrl: './lab-tests-list.component.html',
  styleUrl: './lab-tests-list.component.scss',
  animations: [
    trigger(labTestsListConstants.animationTriggerName, [
      state(labTestsListConstants.animationStateCollapsed, style({ display: 'none' })),
      state(labTestsListConstants.animationStateExpanded, style({ width: '100%' })),
      transition('expanded <=> collapsed', animate('100ms linear', keyframes([
        style({ left: '0', top: '200px', offset: 0 }),
        style({ left: '200px', top: '100px', offset: 0.5 }),
        style({ left: '400px', top: '200px', offset: 1 }),
      ]))),
    ]),
  ],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialDesignModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ]
})
export class LabTestsListComponent implements OnInit, AfterViewInit, OnDestroy {
  private labTestListService = inject(LabTestListService);
  private cdr = inject(ChangeDetectorRef);
  private renderer = inject(Renderer2);
  private dialog = inject(MatDialog);
  private toastr = inject(ToastrService);
  private sharedService = inject(SharedService);
  private route = inject(ActivatedRoute);
  private projectService = inject(ProjectService);
  private fb = inject(FormBuilder);
  private loadingService = inject(LoadingService);
  private document = inject(DOCUMENT);

  @ViewChildren('innerSort') innerSort!: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables!: QueryList<MatTable<unknown>>;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;


  graphImages: unknown[] = [];
  chartList: unknown[] = [];
  formCCECalc!: FormGroup;
  graphDisplay = true;
  phaseOne: unknown;
  phaseTwo: unknown;
  slopeAInterceptA: unknown;
  vSat = 0;
  bubblePoint = 0;
  trendAbove = 0;
  trendBelow = 0;
  rotatedIndex: number | null = null;

  labTestRepeatList: LabTestRepeat[] = [];
  displayColumns = [
    labTestsListConstants.columnWellName,
    labTestsListConstants.columnCylinder,
    labTestsListConstants.columnSamplingType,
    labTestsListConstants.columnCreatedBy,
    labTestsListConstants.columnStatusName,
    labTestsListConstants.columnAction,
  ];
  innerDisplayedColumns = [
    labTestsListConstants.columnExperimentName,
    labTestsListConstants.columnExperimentSequenceNo,
    labTestsListConstants.columnAssignedTo,
    labTestsListConstants.columnCreatedBy,
    labTestsListConstants.columnStatusName,
    labTestsListConstants.columnAction,
  ];
  identifierDisplayedColumns = [
    labTestsListConstants.columnIdentifierIndex,
    labTestsListConstants.columnSampleIdentifier,
    labTestsListConstants.columnExperimentsCount,
  ];
  dataSource = new MatTableDataSource<LabTestSampleRow>();
  errorMessage!: string;
  successMessage!: string;
  pageEvent: PageEvent = {
    pageIndex: environment.paginatorDefaults.pageIndex,
    pageSize: environment.paginatorDefaults.pageSize,
    length: environment.paginatorDefaults.length
  };
  pageSizeOptions = environment.pageSizeOptions;
  pageNumber = environment.paginatorDefaults.pageNumber;
  pageSize = environment.paginatorDefaults.pageSize;
  filterValue = '';
  username: string | undefined;
  user!: UserDetail | undefined;
  expandedElement: LabTestSampleRow | null = null;
  filteredLabTestDataList: LabTestSampleRow[] = [];
  projectId = 0;
  projectNumber = '';

  labTestFilterForm!: FormGroup;
  labtestStatusLookup: { statusId: number | null; statusName: string }[] = [];
  experimentStatusLookup: { statusId: number | null; statusName: string }[] = [];
  status: { statusId: number | null; statusName: string }[] = [];
  labtestStatusValue = filterDefaults.all;
  experimentStatusValue = filterDefaults.all;
  wellValue = filterDefaults.all;
  wellsLookup: string[] = [];
  STATUS_CONSTANTS = STATUS_CONSTANTS;
  STATUS_CONSTANTS_UC = STATUS_CONSTANTS_UC;
  roleIds = roleIds;
  roles = roles;
  reportConstants = reportConstants;

  // Show "at <conditionalTemp>" only for these experiment names
  readonly expNamesShowTemp: ReadonlySet<string> = new Set([reportConstants.experimentNameCCE, reportConstants.experimentNameCCEDewPoint, reportConstants.experimentNameViscosity, reportConstants.experimentNameSwelling]);
  private expandedIdentifierBySample: Record<number, string | null> = {};
  private currentFilterStr = '';
  private readonly noRecordsFoundSampleIdentifier = 'No records found';
  private getLabListData!: Subscription;
  private getUserDetail!: Subscription;
  private getUserRoleId!: Subscription;
  private getLabTestFilterForm!: Subscription;

  ngAfterViewInit(): void {
    this.graphDisplay = false;
  }

  ngOnInit() {
    this.BuildFilterForm();
    this.InitFiltersFromQueryParams();
    this.ListenToFilterChanges();

    this.GetStatus();
    this.getUserDetail = this.sharedService.userDetail$.subscribe((userDetail) => {
      if (userDetail) {
        this.userId = userDetail?.mail;
      }
    });
    this.getUserRoleId = this.sharedService.userRoleId$.subscribe((userRoleId) => {
      if (userRoleId) {
        this.roleId = userRoleId;
      }
    });
    this.projectId = this.route.snapshot.params[labTestsListConstants.routeParamProjectId] ? this.route.snapshot.params[labTestsListConstants.routeParamProjectId] : 0;
    this.projectNumber = this.route.snapshot.params[labTestsListConstants.routeParamProjectNumber] ? this.route.snapshot.params[labTestsListConstants.routeParamProjectNumber] : labTestsListConstants.emptyString;

    this.GetLabTestsListData();
  }

  ngOnDestroy(): void {
    this.getLabListData?.unsubscribe();
    this.getUserDetail?.unsubscribe();
    this.getUserRoleId?.unsubscribe();
    this.getLabTestFilterForm?.unsubscribe();
  }
  private SyncExpandedIdentifier(sample: LabTestSampleRow): void {
    const filteredGroups = sample.filteredSampleIdentifierGroups ?? [];
    if (!filteredGroups.length) {
      this.expandedIdentifierBySample[sample.labTestId] = null;
      return;
    }

    const expandedIdentifier = this.expandedIdentifierBySample[sample.labTestId];
    const exists = filteredGroups.some(g => g.sampleIdentifier === expandedIdentifier);

    if (!exists) {
      const firstToggleableIdentifier = filteredGroups.find((g) => this.IsIdentifierToggleAllowed(g.sampleIdentifier));
      this.expandedIdentifierBySample[sample.labTestId] = firstToggleableIdentifier?.sampleIdentifier ?? null;
    }
  }

  IsIdentifierToggleAllowed(sampleIdentifier: string): boolean {
    return (sampleIdentifier ?? '').trim().toLowerCase() !== this.noRecordsFoundSampleIdentifier.toLowerCase();
  }

  IsIdentifierExpanded(labTestId: number, sampleIdentifier: string): boolean {
    return this.expandedIdentifierBySample[labTestId] === sampleIdentifier;
  }

  // INNER table predicate
  private innerFilterPredicate = (row: LabTestRepeat, filter: string): boolean => {
    return this.labTestListService.ExperimentMatchesAllTokens(row, filter, this.expNamesShowTemp);
  };

  // OUTER table predicate
  private outerFilterPredicate = (sample: unknown, filter: string): boolean => {
    const s = sample as (LabTestList & { labTestRepeat?: LabTestRepeat[] });
    return this.labTestListService.SampleMatchesAllTokens(s, filter, this.expNamesShowTemp);
  };

  goBackToProjectDetails() {
    this.sharedService.NavigateToProjectDetail(this.projectId);
  }

  // Get List of Lab Tests
  GetLabTestsListData() {
    this.loadingService.ShowLoadingSpinner();

    // cancel previous request if still running
    this.getLabListData?.unsubscribe();

    this.getLabListData = this.labTestListService.GetLabTestList(this.projectId).subscribe((response) => {
      if (response.isSuccess) {
        this.filteredLabTestDataList = this.FilterLabTestDataList(
          response?.result
        );
        this.filteredLabTestDataList = this.labTestListService.AttachSampleIdentifierGroups(this.filteredLabTestDataList);
        this.SortListDesc(this.filteredLabTestDataList)
        this.dataSource = new MatTableDataSource(this.filteredLabTestDataList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.wellsLookup = this.labTestListService.BuildWellsLookup(this.filteredLabTestDataList);

        const payload = this.BuildFilterPayload(this.labTestFilterForm.value);
        this.ApplyCompositeFilter(payload);

        this.loadingService.HideLoadingSpinner();
      } else {
        this.loadingService.HideLoadingSpinner();
        this.errorMessage = MC.anErrorOccurredWhileFetchingTheData;
        this.toastr.error(this.errorMessage);
      }
    });
  }
  SortListDesc(listLabTest: LabTestList[]): void {
    this.labTestListService.SortListDesc(listLabTest);
  }
  FilterLabTestDataList(response: unknown[]): (LabTestList & { labTestRepeat: LabTestRepeat[] })[] {
    return this.labTestListService.FilterLabTestDataList(response);
  }

  OnClickNavigate() {
    this.sharedService.NavigateToCreateLabtest();
  }

  OnPageChange(event: { pageIndex: number; pageSize: number }): void {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.GetLabTestsListData();
  }

  // Apply Filter on sample list + inner experiments
  ApplyFilter(event: Event) {
    const raw = (event.target as HTMLInputElement).value ?? '';
    this.filterValue = raw.trim().toLowerCase();

    // Outer table
    this.dataSource.filterPredicate = this.outerFilterPredicate; // ensure it's set
    this.dataSource.filter = this.filterValue;

    // Inner tables
    this.innerTables?.forEach(table => {
      const ds = table.dataSource as MatTableDataSource<LabTestRepeat>;
      if (ds) {
        ds.filterPredicate = this.innerFilterPredicate;
        ds.filter = this.filterValue;
      }
    });
  }

  ToggleRow(element: LabTestSampleRow, index: number | null): void {
    if (index !== null) {
      this.rotatedIndex = this.rotatedIndex === index ? null : index;
    }
    const hasRepeats = !!element?.labTestRepeat?.length;

    if (hasRepeats) {
      const isCurrentlyExpanded = this.expandedElement === element;
      this.expandedElement = isCurrentlyExpanded ? null : element;

      // On sample-row expand, keep identifier list visible but collapse all experiment tables.
      if (this.expandedElement) {
        this.expandedIdentifierBySample[element.labTestId] = null;
      }
    }

    this.cdr.detectChanges();
    this.BindInnerTables();
  }

  ToggleIdentifierRow(sample: LabTestSampleRow, identifierGroup: SampleIdentifierGroup, event?: Event): void {
    event?.stopPropagation();

    if (!this.IsIdentifierToggleAllowed(identifierGroup.sampleIdentifier)) {
      return;
    }

    const sampleId = sample.labTestId;
    const current = this.expandedIdentifierBySample[sampleId];
    this.expandedIdentifierBySample[sampleId] = current === identifierGroup.sampleIdentifier ? null : identifierGroup.sampleIdentifier;

    this.cdr.detectChanges();
    this.BindInnerTables();
  }

  private BindInnerTables(): void {
    this.innerTables?.forEach((table, i) => {
      const innerSort = this.innerSort.toArray()[i];

      if (!(table.dataSource instanceof MatTableDataSource)) {
        const data = Array.isArray(table.dataSource) ? table.dataSource : [];
        table.dataSource = new MatTableDataSource(data);
      }

      const ds = table.dataSource as MatTableDataSource<LabTestRepeat>;
      ds.sort = innerSort;
      ds.filterPredicate = (exp: unknown, filterStr: string) =>
        this.labTestListService.InnerFilterPredicateWithString(exp, filterStr, this.expNamesShowTemp);
      ds.filter = this.currentFilterStr;

      table.renderRows();
    });
  }

  // Navigate to Experiment page
  NavigateExperiment(expandedElement: LabTestRepeat, role: string, isButtonClick: boolean): void {
    const sample = this.filteredLabTestDataList.find(
      (x) => x.labTestId === expandedElement.labTestId
    );

    if (!sample) return;

    const wellName = sample.wellName ?? '';
    const cylinder = sample.cylinder ?? '';
    let reservoirTemperature = sample.reservoirTemperature ?? -1;
    let reservoirPressure = sample.reservoirPressure ?? -1;

    if (!reservoirTemperature || reservoirTemperature < 0) {
      reservoirTemperature = -1;
    }

    if (!reservoirPressure || reservoirPressure < 0) {
      reservoirPressure = -1;
    }

    const experimentShortName = expandedElement.experimentName;
    let redirect = '/' + expandedElement.experimentName.toLowerCase() + '/' + expandedElement.labTestId + '/' + expandedElement.labTestRepeatId +
      '/' + expandedElement.statusId + '/' + wellName + '/' + cylinder + '/' + expandedElement.statusName + '/' + experimentShortName + '/' + expandedElement.experimentSequenceNo
      + '/' + reservoirTemperature + '/' + reservoirPressure;
    this.sharedService.UpdateLabTestRepeatId(expandedElement.labTestRepeatId.toString());
    this.sharedService.UpdateStatusName(expandedElement.statusName);
    if (role === roles.labTech) {
      if ((expandedElement.statusName).toUpperCase() === STATUS_CONSTANTS_UC.Ready && isButtonClick) {
        const updateData: StatusUpdate = {
          labTestId: expandedElement.labTestId,
          labTestRepeatId: expandedElement.labTestRepeatId,
          labStatusId: this.projectService.GetStatusIdByName(STATUS_CONSTANTS.UnderExecution),
          requestStatus: STATUS_CONSTANTS.UnderExecution,
          userId: this.userId,
          role: this.roleId,
          comments: '',
        };
        this.labTestListService
          .UpdateStatusRepeatId(updateData)
          .subscribe((response: APIResponse<unknown>) => {
            if (response.isSuccess) {

              redirect = this.labTestListService.BuildExperimentRoute({
                experimentName: experimentShortName,
                labTestId: expandedElement.labTestId,
                labTestRepeatId: expandedElement.labTestRepeatId,
                statusId: this.projectService.GetStatusIdByName(STATUS_CONSTANTS.UnderExecution),
                wellName,
                cylinder,
                statusName: STATUS_CONSTANTS.UnderExecution,
                experimentSequenceNo: expandedElement.experimentSequenceNo,
                reservoirTemperature,
                reservoirPressure,
              });

              this.sharedService.NavigateToExperimentByPath(redirect, this.projectId, this.projectNumber);
            }
          });
      } else {
        this.sharedService.NavigateToExperimentByPath(redirect, this.projectId, this.projectNumber);
      }
    }
    else {
      this.sharedService.NavigateToExperimentByPath(redirect, this.projectId, this.projectNumber);
    }
  }
  NavigateCreateSample(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.projectService.UpdateIsNewProject(this.projectId > 0 ? false : true);
    this.sharedService.NavigateToCreateSample(this.projectId, this.projectNumber);
  }

  SetValue(controlName: string, value: unknown): void {
    this.formCCECalc.controls[controlName].setValue(value);
  }

  roleId = ''; //1 is lab tech, 2 is fluid engg
  userId = '';

  // Repeat CCE Experiment
  RepeatCCE(labTestId: number, labRepeatId: number, sampleIdentifier: string) {
    const saveRepeatDetails = {
      labTestId: labTestId,
      labTestRepeatId: labRepeatId,
      sampleIdentifier: sampleIdentifier,
      userId: this.userId,
      role: this.roleId,
      comments: '',
    };
    this.labTestListService.RepeatCCE(saveRepeatDetails).subscribe((res) => {
      if (res.isSuccess) {
        // Reload same route with query params instead of full page reload
        this.RefreshSampleList();
      }
    });
  }

  private RefreshSampleList() {
    this.sharedService.NavigateRelativeWithMerge(this.route, {
      projectId: this.projectId,
      projectNumber: this.projectNumber
    }).then(() => {
      this.GetLabTestsListData();
    });
  }

  // Mark Sample as Completed
  CompleteSample(data: LabTestList & { labTestRepeat: LabTestRepeat[]; labRepeatId?: number }) {
    const fndIndex = data.labTestRepeat.filter(
      (x: LabTestRepeat) =>
        x.experimentId?.toString() !== labTestsListConstants.zeroStringLiteral &&
        x.statusName.toUpperCase() !== STATUS_CONSTANTS_UC.Rejected &&
        x.statusName.toUpperCase() !== STATUS_CONSTANTS_UC.Accepted
    );
    if (fndIndex.length > 0) {
      this.toastr.error(MC.acceptOrRejectAllTests);
    } else {
      const saveRepeatDetails: StatusUpdate = {
        labTestId: data.labTestId,
        labTestRepeatId: data.labRepeatId ?? 0,
        labStatusId: this.projectService.GetStatusIdByName(STATUS_CONSTANTS.Completed),
        requestStatus: STATUS_CONSTANTS.Completed,
        comments: '',
        userId: this.userId,
        role: this.roleId,
        wellName: data.wellName,
        cylinder: data.cylinder,
      }
      this.labTestListService.UpdateAcceptAndRejectStatusRepeatId(saveRepeatDetails).subscribe(
        (res: APIResponse<unknown>) => {
          if (res.isSuccess) {
            this.toastr.success(MC.testsCompletedSuccessfully);
            this.RefreshSampleList();
          }
        }
      );
    }
  }

  DownloadTemplate(labRepeatId: number, experimentType: string): void {
    const testRepeatId = labRepeatId;
    this.labTestListService.DownloadTemplate(testRepeatId, experimentType).subscribe(blob => {
      const link: HTMLAnchorElement = this.renderer.createElement('a');
      const objectUrl = this.document.defaultView?.URL.createObjectURL(blob);
      if (!objectUrl) {
        return;
      }
      link.href = objectUrl;
      link.download = `${labTestsListConstants.reportFilePrefix}${experimentType}_${testRepeatId}${labTestsListConstants.excelExtension}`;
      link.click();

    }, error => {
      console.error('Download failed:', error);
    });
  }


  TransformComponents(components: Record<string, unknown>[]): Record<string, unknown>[] {
    return this.labTestListService.TransformComponents(components);
  }
  onEditSample(labTestId: number) {
    this.projectService.UpdateIsNewProject(this.projectId > 0 ? false : true);
    this.sharedService.NavigateToEditSample(this.projectId, this.projectNumber, labTestId);
  }


  private BuildFilterForm(): void {
    this.labTestFilterForm = this.fb.group({
      search: [labTestsListConstants.emptyString],
      well: [filterDefaults.all],
      labtestStatus: [filterDefaults.all],
      experimentStatus: [filterDefaults.all],
      dateRange: this.fb.group({
        start: [null],
        end: [null],
      }),
    });
  }


  private InitFiltersFromQueryParams(): void {
    const q = this.route.snapshot.queryParamMap;

    const startStr = q.get(labTestsListConstants.queryParamStartDate);
    const endStr = q.get(labTestsListConstants.queryParamEndDate);

    this.labTestFilterForm.patchValue({
      search: q.get(labTestsListConstants.queryParamSearch) ?? labTestsListConstants.emptyString,
      well: q.get(labTestsListConstants.queryParamWell) ?? labTestsListConstants.emptyString,
      labtestStatus: q.get(labTestsListConstants.queryParamSampleStatus) ?? labTestsListConstants.emptyString,
      experimentStatus: q.get(labTestsListConstants.queryParamExpStatus) ?? labTestsListConstants.emptyString,
      dateRange: {
        start: startStr ? new Date(startStr) : null,
        end: endStr ? new Date(endStr) : null,
      },
    }, { emitEvent: false });
  }


  ResetFilters(): void {
    this.labTestFilterForm.reset({
      search: labTestsListConstants.emptyString,
      well: filterDefaults.all,
      labtestStatus: filterDefaults.all,
      experimentStatus: filterDefaults.all,
      dateRange: { start: null, end: null },
    });
  }

  GetStatus(): void {
    this.projectService.GetStatusList().subscribe(() => {
      if (this.projectService.statusList$ !== null) {
        const lookups = this.labTestListService.BuildStatusLookups(this.projectService.statusList$.value ?? []);
        this.experimentStatusLookup = lookups.experimentStatusLookup;
        this.labtestStatusLookup = lookups.labtestStatusLookup;
      }
    });
  }

  private BuildFilterPayload(val: Record<string, unknown>): LabTestFilter {
    return this.labTestListService.BuildFilterPayload(val);
  }

  private SerializeFilter(f: LabTestFilter): string {
    return this.labTestListService.SerializeFilter(f);
  }

  private DeserializeFilter(filterStr: string): LabTestFilter {
    return this.labTestListService.DeserializeFilter(filterStr);
  }


  private ListenToFilterChanges(): void {
    this.getLabTestFilterForm = this.labTestFilterForm.valueChanges
      .pipe(debounceTime(150))
      .subscribe((val: Record<string, unknown>) => {
        const payload = this.BuildFilterPayload(val);

        this.sharedService.NavigateRelativeWithMerge(this.route, {
          [labTestsListConstants.queryParamSearch]: val['search'] || null,
          [labTestsListConstants.queryParamWell]: val['well'] || null,
          [labTestsListConstants.queryParamSampleStatus]: val['labtestStatus'] || null,
          [labTestsListConstants.queryParamExpStatus]: val['experimentStatus'] || null,
          startDate: payload.startDate ? payload.startDate.toISOString() : null,
          endDate: payload.endDate ? payload.endDate.toISOString() : null,
        });

        this.ApplyCompositeFilter(payload);
      });
  }

  private ApplyCompositeFilter(payload: LabTestFilter) {
    const filterStr = this.SerializeFilter(payload);
    this.currentFilterStr = filterStr;

    // OUTER table
    this.dataSource.filterPredicate = (sample: unknown, filter: string) =>
      this.labTestListService.OuterFilterPredicateWithString(sample, filter, this.expNamesShowTemp);
    this.dataSource.filter = filterStr;

    this.filteredLabTestDataList = this.labTestListService.ApplyCompositeFilterToSamples(this.filteredLabTestDataList, payload, this.expNamesShowTemp);
    this.dataSource.data = this.filteredLabTestDataList;
    this.filteredLabTestDataList.forEach(sample => this.SyncExpandedIdentifier(sample));


    // INNER tables
    this.innerTables?.forEach(table => {
      const ds = table.dataSource as MatTableDataSource<LabTestRepeat>;
      if (ds) {
        ds.filterPredicate = (exp: unknown, filter: string) =>
          this.labTestListService.InnerFilterPredicateWithString(exp, filter, this.expNamesShowTemp);
        ds.filter = filterStr;
      }
    });
  }


  // INNER predicate (experiments)
  private InnerFilterPredicateWithString = (exp: unknown, filterStr: string): boolean => {
    return this.labTestListService.InnerFilterPredicateWithString(exp, filterStr, this.expNamesShowTemp);
  };

  // OUTER predicate (samples)
  private outerFilterPredicateWithString = (sample: unknown, filterStr: string): boolean => {
    return this.labTestListService.OuterFilterPredicateWithString(sample, filterStr, this.expNamesShowTemp);
  };

}
